module.exports = __webpack_public_path__ + "img/memory_100.eb9462b1.jpg";